module.exports = __webpack_public_path__ + "static/media/bK.e3451fff.svg";